import React from 'react';
import { Box } from '@mui/material';
import TradingViewSignalMonitor from '../../components/TradingViewSignalMonitor/TradingViewSignalMonitor';

const TradingViewWebhookMonitor = () => {
  const apiBaseUrl = process.env.REACT_APP_API_URL || '/';
  const wsUrl = apiBaseUrl.replace('http', 'ws') + '/ws/tradingview-signals/';

  return (
    <Box sx={{ width: '100%' }}>
      <TradingViewSignalMonitor wsUrl={wsUrl} />
    </Box>
  );
};

export default TradingViewWebhookMonitor;
